import React, { useMemo } from 'react';
import { Text, Stack } from '@chaser/components';
import byteSize from '../../util/byteSize';

const FileUploadInfoDefault = ({ multiple, maxSize, accept }) => {
  const supportedExtensions = useMemo(
    () =>
      accept
        ? Object.values(accept)
            .flat()
            .join(', ')
        : null,
    [accept],
  );
  const humanMaxSize = useMemo(() => (maxSize ? byteSize(maxSize) : null), [maxSize]);

  return (
    <Stack gap="small" color="Mid Neutral 1">
      <Text fontWeight="bold">
        Drag and drop to upload or select {multiple ? 'multiple files' : 'a file'}
      </Text>
      <Stack gap="xsmall">
        <Text fontSize="micro">Max upload size: {humanMaxSize || 'unlimited'}</Text>
        <Text fontSize="micro">Supported file format: {supportedExtensions || 'any'}</Text>
      </Stack>
    </Stack>
  );
};

export default FileUploadInfoDefault;
